import qs from "qs";

export function getLocalHrefQuery(query: string) {
  const url = window.location.href;
  const search = url.substring(url.indexOf("?") + 1);
  const params = qs.parse(search);
  const shareQ = params[query];
  return shareQ;
}

export function getLocalShareQ() {
  return getLocalHrefQuery("q");
}

export function isShareWebApp() {
  return getLocalShareQ();
}
